import { useMutation, useQueryClient } from "@tanstack/react-query";
import { configApi } from "@/lib/api";

export function useGenerateConfig() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (module: string) => configApi.generate(module),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["config-status"] }),
  });
}

export function useReloadConfig() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (module: string) => configApi.reload(module),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["config-status"] }),
  });
}
